import { render, staticRenderFns } from "./AttendanceModule.vue?vue&type=template&id=679e002e"
import script from "./AttendanceModule.vue?vue&type=script&lang=js"
export * from "./AttendanceModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports